import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/customer-care.scss";

function CareGuide() {
  return (
    <main className="policy-page customer-care">
      <header>
        <p className="eyebrow">Product care</p>
        <h1>Garment care guide</h1>
        <p>Simple, material-specific habits can preserve shape, texture and colour for longer.</p>
      </header>
      <section className="policy-accordions">
        <details open><summary>Always begin with the label</summary><p>The care label attached to your garment takes priority over general guidance. Treat trims, linings and mixed fibres according to the most delicate component.</p></details>
        <details><summary>Wool &amp; cashmere</summary><p>Air between wears, fold rather than hang knitwear, and use a wool comb sparingly. Hand wash only when the label permits, using cool water and a suitable detergent; dry flat away from heat.</p></details>
        <details><summary>Cotton, denim &amp; linen</summary><p>Wash similar colours together at the label temperature, close fastenings and turn dark garments inside out. Reshape while damp and avoid excessive tumble drying.</p></details>
        <details><summary>Faux leather &amp; microsuede</summary><p>Wipe small marks with a soft barely damp cloth. Keep away from direct heat, perfume and prolonged moisture, and use a specialist cleaner for deeper treatment.</p></details>
        <details><summary>Coats &amp; tailoring</summary><p>Allow pieces to rest on a supportive hanger and brush away surface dust. Dry clean only when needed and as directed by the garment label.</p></details>
        <details><summary>Need product-specific help?</summary><p>Send the product name and your question to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p></details>
      </section>
    </main>
  );
}

export default CareGuide;
